const translations = Object.assign(
  {},
  require("../../node_modules/front-commerce/translations/en.json"),
  require("../../node_modules/front-commerce/theme-chocolatine/translations/en.json"),
  require("../../node_modules/front-commerce/modules/front-commerce-b2b/translations/en.json"),
  require("../../translations/en.json")
);
module.exports = translations;
